<template>
    <div class="error">
        <i class="iconfont">&#xe613;</i>
        <p>该店铺不存在</p>
        <router-link tag="button" to="/">返回首页</router-link>
    </div>
</template>

<script>
export default {
  name: 'ErrorMess'
}
</script>

<style scoped>
.error{ text-align: center; padding-top: 60%;}
.iconfont{ font-size: 50px; color: #f00; padding-bottom: 10px; display: block;}
.error p{ font-size: 20px;}
.error button{ background: #f00; color: #fff; width: 60%; display: block; margin: 20px auto; border: 0; padding: 10px 0; border-radius: 3px;}
</style>



// WEBPACK FOOTER //
// src/pages/error/components/Mess.vue